import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Login          from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import AuthCallback   from "./pages/AuthCallback";
import Dashboard      from "./pages/Dashboard";
import Clients        from "./pages/Clients";
import ClientForm     from "./pages/ClientForm";
import Employees      from "./pages/Employees";
import Jobs           from "./pages/Jobs";
import Finance        from "./pages/Finance";
import Commissions    from "./pages/Commissions";
import AppLayout      from "./components/layout/AppLayout";

function RequireAuth({ children }) {
  const { session, profile, loading, signOut } = useAuth();

  if (loading) return (
    <div style={{
      display:"flex", alignItems:"center", justifyContent:"center",
      height:"100vh", color:"#718096", fontFamily:"Inter,sans-serif",
    }}>
      Loading…
    </div>
  );

  if (!session) return <Navigate to="/login" replace />;

  if (!profile) return (
    <div style={{
      display:"flex", flexDirection:"column", alignItems:"center",
      justifyContent:"center", height:"100vh", fontFamily:"Inter,sans-serif",
      textAlign:"center", padding:"2rem", gap:"1rem",
    }}>
      <div style={{ fontSize:"2rem" }}>⚠️</div>
      <div style={{ fontSize:"16px", fontWeight:600, color:"#1a202c" }}>
        Account not linked
      </div>
      <div style={{ fontSize:"14px", color:"#718096", maxWidth:"360px", lineHeight:1.6 }}>
        Your login exists but is not linked to an employee record.
        Please contact your administrator.
      </div>
      <button onClick={signOut} style={{
        padding:"8px 20px", background:"#c0392b", color:"#fff",
        border:"none", borderRadius:"6px", fontSize:"13px",
        fontWeight:600, cursor:"pointer",
      }}>
        Sign Out
      </button>
    </div>
  );

  return children;
}

function AdminOnly({ children }) {
  const { isAdmin, loading } = useAuth();
  if (loading) return null;
  if (!isAdmin) return <Navigate to="/dashboard" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login"           element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/callback"   element={<AuthCallback />} />

      {/* Protected routes */}
      <Route path="/" element={<RequireAuth><AppLayout /></RequireAuth>}>
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard"         element={<Dashboard />} />
        <Route path="clients"           element={<Clients />} />
        <Route path="clients/new"       element={<ClientForm />} />
        <Route path="clients/:id/edit"  element={<ClientForm />} />
        <Route path="finance"           element={<Finance />} />
        <Route path="commissions"       element={<Commissions />} />
        <Route path="jobs"              element={<Jobs />} />
        <Route path="employees"         element={<AdminOnly><Employees /></AdminOnly>} />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}